import PropTypes from 'prop-types';


const Can = ({ permissions, featureFlags, perform, flag, readOnly = false, yes = () => null, no = () => null }) => {
  const $permissions = readOnly
    ? permissions.filter((d) => d.includes('read'))
    : permissions;
  const $featureFlags = featureFlags || [];

  if (flag instanceof Array) {
    for (let i = 0; i < flag.length; i++) {
      if (!$featureFlags.includes(flag[i])) {
        return no();
      }
    }
  }

  if (typeof flag === 'string') {
    if (!$featureFlags.includes(flag)) {
      return no();
    }
  }

  if (flag instanceof Array) {
    for (let i = 0; i < flag.length; i++) {
      if (!featureFlags.some(flag[i])) {
        return no();
      }
    }
  }

  if (typeof flag === 'string') {
    if (!featureFlags.includes(flag)) {
      return no();
    }
  }

  if (flag instanceof Array) {
    for (let i = 0; i < flag.length; i++) {
      if (!featureFlags.some(flag[i])) {
        return no();
      }
    }
  }

  if (typeof flag === 'string') {
    if (!featureFlags.includes(flag)) {
      return no();
    }
  }

  // If Permissions is an array
  if (perform instanceof Array) {
    for (let i = 0; i < perform.length; i++) {
      if ($permissions.includes(perform[i])) {
        return yes();
      }
    }
    return no();
  }
  // If Permissions is a string
  if (typeof perform === 'string') {
    if ($permissions.includes(perform)) {
      return yes();
    }
    return no();
  }
};

Can.propTypes = {
  permissions: PropTypes.array,
  featureFlags: PropTypes.array,
  perform: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  flag: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  readOnly: PropTypes.bool,
  yes: PropTypes.func,
  no: PropTypes.func,
};

export default Can;
